import { Component, ViewChild } from '@angular/core';
import { ApiService } from '../../core/services/api.service';
import { MessageService } from '../../core/services/message.service';
import { HttpParams } from '@angular/common/http';
import { LoadInfo } from '../tickets/shared/load-info';
import { FileSystemFileEntry, FileSystemDirectoryEntry, UploadEvent } from 'ngx-file-drop';
import { DataTableComponent } from '../../shared/data-table/data-table.component';
@Component({
    selector: 'orders',
    templateUrl: './orders.component.html',
    styleUrls: ['./orders.component.scss']
})

export class OrdersComponent {

    options = {
        columnTitles: ["Número de Orden de Etiqueta","Fecha", "Usuario" ,"Seleccinar"],
        columnReferences: ["order","dateCreation","user","actions"],
        actionButtons: { detail: false, selectable: true}
    }
    search = {
        "user":"",
        "order":"",
        "initDate":"",
        "endDate":""};
    generalSelection = false;
    selectedFile : any;
    fileSize: any;
    @ViewChild("tableChild") tableChild: DataTableComponent<LoadInfo>;
    
    constructor(
        private apiService: ApiService,
        private messageService: MessageService) { }
    searchLoad(obj){
        let searchOb = obj;
        //if(typeof(s.initDate)=='object'&&s.initDate!=null){ searchOb.initDate = s.initDate.getFullYear()+"-"+("0"+(s.initDate.getMonth()+1)).substr(-2)+"-"+("0"+s.initDate.getDate()).substr(-2); }
        //if(typeof(s.endDate)=='object'&&s.endDate!=null){ searchOb.endDate = s.endDate.getFullYear()+"-"+("0"+(s.endDate.getMonth()+1)).substr(-2)+"-"+("0"+s.endDate.getDate()).substr(-2); }
        this.tableChild.firstPage();
        this.tableChild.loadPage(searchOb);
    }
    changeSelection(tableData:any){
        for(let i = 0;i<tableData.dataSource.dataSubject._value.length;i++){
            tableData.dataSource.dataSubject._value[i].selected = this.generalSelection;
        }
        console.log(tableData.dataSource.dataSubject._value);
    }
    imprSelec(tableData:any){
        let content = tableData.dataSource.dataSubject._value;
        let ids = [];
        content.forEach(element => {
        if(element.selected){
            ids.push(element.idShip);
        }
        });
        if(ids.length>0){
            this.apiService.post('api/OrderPrint/Print',ids).subscribe((response: any) => {
                if (response) {
                    window.open(response.data);
                }
            })
        }
    }
    formatBytes(a, b) {
        if (0 == a) return "0 Bytes";
        var c = 1024,
          d = b || 2,
          e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
          f = Math.floor(Math.log(a) / Math.log(c));
        return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f]
    }
    sendFile() {
        const formData = new FormData();
        formData.append(this.selectedFile.name, this.selectedFile);
        this.apiService.post("api/OrderPrint/Print", formData).subscribe((response:any) => {
          window.open(response.data);
        });
    }
    public dropped(event: UploadEvent) {
        let droppedFile = event.files[0];
        // Is it a file?
        if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
            console.log(droppedFile.relativePath, file);
            this.selectedFile = file;
            this.fileSize = this.formatBytes(this.selectedFile.size, 2);
            console.log(this.selectedFile);
        });
        } else {
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
        console.log(droppedFile.relativePath, fileEntry);
        }
    } 
}
